import React from "react";
import { Button, message } from "antd";
import { getPaymentUrl } from "@/api/payment";
import { useTranslation } from "react-i18next";

const App: React.FC<{
  amount: number;
  disabled?: boolean;
  buttonLoading?: boolean;
  setButtonLoading?: (loading: boolean) => void;
}> = ({ amount, disabled, buttonLoading, setButtonLoading }) => {
  const { t } = useTranslation();

  const handleConfirm = async () => {
    setButtonLoading && setButtonLoading(true);
    try {
      let href = window.location.href;
      if (!href.includes('?')) {
        href += `?amount=${amount}`;
      }
      else {
        href += `&amount=${amount}`;
      }
      const data = await getPaymentUrl({
        amount,
        url: href,
      });
      const url = data?.url;

      if (data?.message) {
        message.error(data.message);
      } else if (url) {
        window.location.replace(url);
      }
    } catch (error) {
      message.error(t('components.modalPaymentMoney.failedToGetPaymentAddress'));
    } finally {
      setButtonLoading && setButtonLoading(false);
    }
  };

  return (
    <>
      <Button
        style={{ width: "110px" }}
        type="primary"
        loading={buttonLoading}
        onClick={handleConfirm}
        disabled={disabled}
      >
        {t('components.modalPaymentMoney.next')}
      </Button>
    </>
  );
};

export default App;
